import React, { useState } from "react";
import { Globe, ChevronDown, Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const LANG_OPTIONS = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "da", label: "Dansk", flag: "🇩🇰" },
];

export default function LanguageSwitcher({ variant = "header" }) {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const current = LANG_OPTIONS.find((l) => l.code === lang) || LANG_OPTIONS[0];

  const baseCls =
    variant === "header"
      ? "flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-[#D4A94A]/40 text-[#FBEFD9] hover:border-[#D4A94A] transition-colors text-xs"
      : "flex items-center gap-2 px-3 py-2 rounded-full bg-[#1B1512]/60 border border-[#D4A94A]/40 text-[#FBEFD9] hover:border-[#D4A94A] transition-colors text-sm";

  return (
    <div className="relative">
      <button onClick={() => setOpen((v) => !v)} className={baseCls} aria-label="Language">
        <Globe size={13} />
        <span>{current.flag}</span>
        <span className="hidden md:inline">{current.code.toUpperCase()}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-40 bg-[#1B1512] border border-[#D4A94A]/40 rounded-lg shadow-2xl overflow-hidden z-50">
            {LANG_OPTIONS.map((opt) => (
              <button
                key={opt.code}
                onClick={() => { setLang(opt.code); setOpen(false); }}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left hover:bg-[#7A1F1F]/60 transition-colors ${
                  lang === opt.code ? "bg-[#7A1F1F]/40 text-[#E9C97A]" : "text-[#FBEFD9]"
                }`}
              >
                <span className="text-base">{opt.flag}</span>
                <span className="flex-1">{opt.label}</span>
                {lang === opt.code && <Check size={14} className="text-[#E9C97A]" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
